import { TCoreLabels } from "../types/core-label-types";

const sv: TCoreLabels = {
  READ_MORE: "Läs mer",
  ALL: "Alla",
  CLICK_TO_EXPAND: "Klicka för att expandera",
  CLICK_TO_COLLAPSE: "Klicka för att kollapsa",
  CLICK_TO_PLAY_VIDEO_IN_LARGE_PLAYER: "Klicka för att spela upp video i stor spelare",
  CATEGORY: "Kategori",
  LOCATION: "Ort",
  CLICK_TO_READ_MORE_ABOUT: "Klicka för att läsa mer om",
  YEAR: "År",
  TYPE: "Typ",
  LANGUAGE: "Språk",
  NEWS: "Nyhet",
  NO_MATCHING_RESULTS: "Det finns inga resultat som matchar din filtrering. Testa ändra filtrering!",
  COMING: "Kommer",
  COMING_LATER: "Kommer senare",
  CLICK_TO_DOWNLOAD: "Klicka för att ladda ner",
  PHONE: "Telefon",
  EMAIL: "E-post",
  GO_TO: "Gå till",
  BACK: "Tillbaka",
  TODAY: "Idag",
  PLAY_VIDEO: "Spela video",
  NEXT_PAGE: "Nästa sida",
  PREVIOUS_PAGE: "Föregående sida",

  HEADER_LANGUAGE_SELECTION_ARIA_LABEL: "Språkval",
  HEADER_SEARCH_ARIA_LABEL: "Sök",
  HEADER_MENU_ARIA_LABEL: "Meny",

  FOOTER_VISIT_FACEBOOK: "Besök Facebook",
  FOOTER_VISIT_X: "Besök X",
  FOOTER_VISIT_INSTAGRAM: "Besök Instagram",
  FOOTER_VISIT_YOUTUBE: "Besök YouTube",
  FOOTER_VISIT_LINKEDIN: "Besök LinkedIn",

  JOB_AVAILABLE_POSITION: "Ledig tjänst",
  JOB_TITLE: "Tjänst",
  JOB_LOCATION: "Ort",
  JOB_EMPLOYMENT_TYPE: "Anställningstyp",
  JOB_CONTACT: "Kontaktperson",
  JOB_APPLY_HERE: "Ansök här",
  JOB_CTA_HEADING: "Kontaktuppgifter & Ansökan",
  JOB_APPLY_LAST_DAY: "Sista ansökningsdatum",

  LANGAUGE: "Språk",
  LANGUAGE_SV: "Svenska",
  LANGUAGE_EN: "English",

  SEARCH_SEARCH_HERE: "Sök här",
  SEARCH_SEARCH: "Sök",
  SEARCH_IS_LOADING: "Laddar resultat...",
  SEARCH_NOT_SEARCHED_YET: "Sök efter något i sökfältet ovan för att visa resultat",
  SEARCH_RESULTS_FOUND: "resultat hittades",
  SEARCH_GENERAL_ERROR: "Ett fel uppstod. Det gick inte att hämta sökresultat.",

  REPORT_LIST_ANNUAL_REPORTS: "Årliga rapporter",
  REPORT_LIST_INVESTOR_CALL: "Investor Call",
  REPORT_LIST_PUBLISHED_DATE: "Publiceringsdatum",
  REPORT_LIST_REPORT: "Redovisning",
  REPORT_LIST_ANNUAL_REPORT: "Årsredovisning",
  REPORT_LIST_SUSTAINABILITY_REPORT: "Hållbarhetsredovisning",
  REPORT_LIST_INTERIM_REPORT: "Kvartalsrapport",

  CISION_PRM: "Pressmeddelande",
  CISION_INB: "Inbjudan",
  CISION_KMK: "Bokslutskommuniké",
  CISION_NBR: "Nyhet",
  CISION_RDV: "Årsredovisning",

  INPUT_FIELD_REQUIRED: "Obligatoriskt fält",
  INPUT_FIELD_FALLBACK_ERROR_MESSAGE: "Felaktigt ifyllt fält, försök igen.",
};

const en: TCoreLabels = {
  READ_MORE: "Read more",
  ALL: "All",
  CLICK_TO_EXPAND: "Click to expand",
  CLICK_TO_COLLAPSE: "Click to collapse",
  CLICK_TO_PLAY_VIDEO_IN_LARGE_PLAYER: "Click to play video in large player",
  CATEGORY: "Category",
  LOCATION: "Location",
  CLICK_TO_READ_MORE_ABOUT: "Click to read more about",
  YEAR: "Year",
  TYPE: "Type",
  LANGUAGE: "Language",
  NEWS: "News",
  NO_MATCHING_RESULTS: "There are no results matching your filter. Try changing filters!",
  COMING: "Coming",
  COMING_LATER: "Coming later",
  CLICK_TO_DOWNLOAD: "Click to download",
  PHONE: "Phone",
  EMAIL: "Email",
  GO_TO: "Go to",
  BACK: "Back",
  TODAY: "Today",
  PLAY_VIDEO: "Play video",
  NEXT_PAGE: "Next page",
  PREVIOUS_PAGE: "Previous page",

  HEADER_LANGUAGE_SELECTION_ARIA_LABEL: "Language selection",
  HEADER_SEARCH_ARIA_LABEL: "Search",
  HEADER_MENU_ARIA_LABEL: "Menu",

  FOOTER_VISIT_FACEBOOK: "Visit Facebook",
  FOOTER_VISIT_X: "Visit X",
  FOOTER_VISIT_INSTAGRAM: "Visit Instagram",
  FOOTER_VISIT_YOUTUBE: "Visit YouTube",
  FOOTER_VISIT_LINKEDIN: "Visit LinkedIn",

  JOB_AVAILABLE_POSITION: "Available position",
  JOB_TITLE: "Job Title",
  JOB_LOCATION: "Location",
  JOB_EMPLOYMENT_TYPE: "Employment Type",
  JOB_CONTACT: "Contact",
  JOB_APPLY_HERE: "Apply here",
  JOB_CTA_HEADING: "Contact & Application",
  JOB_APPLY_LAST_DAY: "Last date to apply",

  LANGAUGE: "Language",
  LANGUAGE_SV: "Svenska",
  LANGUAGE_EN: "English",

  SEARCH_SEARCH_HERE: "Search here",
  SEARCH_SEARCH: "Sök",
  SEARCH_IS_LOADING: "Loading results...",
  SEARCH_NOT_SEARCHED_YET: "Search by typing something in the search field above",
  SEARCH_RESULTS_FOUND: "results found",
  SEARCH_GENERAL_ERROR: "An error occurred. Could not fetch search results.",

  REPORT_LIST_ANNUAL_REPORTS: "Annual reports",
  REPORT_LIST_INVESTOR_CALL: "Investor Call",
  REPORT_LIST_PUBLISHED_DATE: "Published date",
  REPORT_LIST_REPORT: "Report",
  REPORT_LIST_ANNUAL_REPORT: "Annual Report",
  REPORT_LIST_SUSTAINABILITY_REPORT: "Sustainability Report",
  REPORT_LIST_INTERIM_REPORT: "Interim Report",

  CISION_PRM: "Press release",
  CISION_INB: "Invite",
  CISION_KMK: "Year-end report",
  CISION_NBR: "News",
  CISION_RDV: "Annual report",

  INPUT_FIELD_REQUIRED: "Required field",
  INPUT_FIELD_FALLBACK_ERROR_MESSAGE: "Incorrectly filled field, please try again.",
};

const defaultLabels = {
  sv,
  en,
};

export default defaultLabels;
